/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, {
  ReactElement, ReactNode, useEffect, useState,
} from 'react';

import Footer from '../footer';

type LayoutProps = {
  className?: string
  children: ReactNode
};

const defaultProps = {
  className: '',
};

const Layout: React.FC<LayoutProps> = ({ className, children }: LayoutProps): ReactElement => {
  const [minHeight, setMinHeight] = useState(window.innerHeight);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let resizeListener: any = window.addEventListener('resize', () => {
      setMinHeight(window.innerHeight);
    });
    return () => {
      window.removeEventListener('resize', resizeListener);
      resizeListener = null;
    };
  }, []);

  return (
    <div className={className}>
      <div className="layout-container" style={{ minHeight: `${minHeight}px` }}>
        <main>{children}</main>
        <Footer />
      </div>
    </div>
  );
};

Layout.defaultProps = defaultProps;

export default Layout;
